import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BASE_URL from "api/Api";
import { FaArrowLeft, FaMapMarkedAlt, FaSave } from "react-icons/fa";
import "assets/theme/admin_form.css";

const AddSubdistrict = () => {
  const navigate = useNavigate();
  const [districts, setDistricts] = useState([]);
  const [formData, setFormData] = useState({
    district_id: "",
    subdistrict_name: "",
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetch(`${BASE_URL}super_admin/list_district`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => setDistricts(data.districts || data))
      .catch((err) => console.error(err));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.district_id) {
      newErrors.district_id = "Please select a district";
    }
    if (!formData.subdistrict_name.trim()) {
      newErrors.subdistrict_name = "Subdistrict name is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;
    setSubmitting(true);

    try {
      const res = await fetch(`${BASE_URL}super_admin/add_subdistrict`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      alert("Subdistrict added successfully");
      navigate("/subdistrict-list");
    } catch (error) {
      alert(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-3 admin-form-container">
        {/* Header Card with Left Back Arrow */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 position-relative" style={{ zIndex: 1 }}>
            <div className="d-flex align-items-center gap-3">
              <button
                type="button"
                onClick={() => navigate("/subdistrict-list")}
                className="btn-admin-back"
                title="Back to Subdistrict List"
              >
                <FaArrowLeft /> <span>मागे जा (Back)</span>
              </button>

              <div className="admin-header-icon">
                <FaMapMarkedAlt />
              </div>

              <div>
                <h4 className="text-white fw-bold mb-0" style={{ fontSize: "1.25rem" }}>
                  नवीन तालुका जोडा / Add Subdistrict
                </h4>
                <p className="text-white-50 mb-0 small">
                  District-wise administrative subdistrict registration
                </p>
              </div>
            </div>

            <Link to="/subdistrict-list" className="btn btn-outline-light btn-sm fw-semibold rounded-pill px-3">
              Subdistrict List / यादी
            </Link>
          </div>
        </div>

        {/* Form Card */}
        <div className="admin-form-card">
          <div className="card-body">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row g-4">
                {/* District Dropdown */}
                <div className="col-md-6">
                  <label className="admin-form-label">
                    Select District / जिल्हा निवडा <span className="required-star">*</span>
                  </label>

                  <select
                    className={`admin-form-select ${errors.district_id ? "border-danger" : ""}`}
                    name="district_id"
                    value={formData.district_id}
                    onChange={handleChange}
                  >
                    <option value="">Select District</option>
                    {districts.map((district) => (
                      <option key={district.district_id} value={district.district_id}>
                        {district.district_name}
                      </option>
                    ))}
                  </select>

                  {errors.district_id && (
                    <small className="text-danger fw-semibold d-block mt-1">{errors.district_id}</small>
                  )}
                </div>

                {/* Subdistrict Name */}
                <div className="col-md-6">
                  <label className="admin-form-label">
                    Subdistrict Name / तालुक्याचे नाव <span className="required-star">*</span>
                  </label>

                  <input
                    type="text"
                    className={`admin-form-control ${errors.subdistrict_name ? "border-danger" : ""}`}
                    name="subdistrict_name"
                    placeholder="e.g. Haveli, Mulshi / हवेली, मुळशी"
                    value={formData.subdistrict_name}
                    onChange={handleChange}
                  />
                  {errors.subdistrict_name && (
                    <small className="text-danger fw-semibold d-block mt-1">{errors.subdistrict_name}</small>
                  )}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="d-flex align-items-center justify-content-end gap-3 mt-4 pt-3 border-top">
                <Link to="/subdistrict-list" className="btn-admin-cancel">
                  रद्द करा (Cancel)
                </Link>
                <button
                  type="submit"
                  className="btn-admin-submit"
                  disabled={submitting}
                >
                  <FaSave />
                  <span>{submitting ? "जतन होत आहे..." : "जतन करा (Save Subdistrict)"}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddSubdistrict;
